import { FC } from 'react';
import { IconType } from 'react-icons';
import { HiOutlineFolderOpen } from 'react-icons/hi2';

interface AttachEmptyProps {
    title?: string;
    hint?: string;
    Icon?: IconType;
}

const AttachEmpty: FC<AttachEmptyProps> = ({
    title = 'Ничего не найдено',
    hint = 'Измените запрос или сбросьте фильтры по колонкам.',
    Icon = HiOutlineFolderOpen,
}) => (
    <div className="atb__empty">
        <Icon aria-hidden />
        <h3>{title}</h3>
        <p>{hint}</p>
    </div>
);

export default AttachEmpty;
